import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { DrReportsNavigationService } from '../../../common/services/support/dr-reports-navigation/dr-reports-navigation.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Claim } from '../../../models/claim';
import { ClaimsService } from '../../../common/services/data-model/app/claims/claims.service';
import { MatDialog } from '@angular/material/dialog';
import { ProvideFeedbackModalComponent } from './provide-feedback-modal/provide-feedback-modal.component';
import { CommercialGapProviderService } from '../../../common/services/data-model/app/commercial-gap-provider/commercial-gap-provider.service';
import { AuthorizationsService } from '../../../common/services/data-model/app/authorizations/authorizations.service';

@Component({
  selector: 'app-print-view-reports',
  templateUrl: './print-view-reports.component.html',
  styleUrls: ['./print-view-reports.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrintViewReportsComponent implements OnInit {
  public showAuthorizationDetailsReport = false;

  constructor(
    private claimsService: ClaimsService,
    private drReportsNavigationService: DrReportsNavigationService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,
    private authorizationsService: AuthorizationsService,
    private commercialGapProviderService: CommercialGapProviderService,
    private cdr: ChangeDetectorRef
  ) { }

  private originalClaim: Claim;

  ngOnInit(): void {
    const originalClaim: Claim = this.claimsService.getOriginalClaim();

    this.authorizationsService.retrieveAuthorization(originalClaim.trackingNumber).subscribe(() => {
      const networkId = this.authorizationsService.getNetworkIdFromVsr(originalClaim.trackingNumber);

      this.commercialGapProviderService.shouldShowCommercialGapReport(networkId).subscribe((showReport) => {
        this.showAuthorizationDetailsReport = showReport;
        this.cdr.detectChanges();
      });
    });
  }

  onReportsButtonClick(): void {
    this.originalClaim = this.claimsService.getOriginalClaim();
    this.drReportsNavigationService.navigateToPatientRecordReport(this.originalClaim.trackingNumber);
  }

  onAuthDetailsButtonClick(): void {
    this.originalClaim = this.claimsService.getOriginalClaim();
    this.drReportsNavigationService.showAuthDetailsReport(this.originalClaim.trackingNumber);
  }

  print(): void {
    if (this.deviceService.browser.indexOf('Firefox') <= -1) {
      window.print();
    }
  }

  onProvideFeedbackClick(): void {
    const dialogRef = this.dialog.open(ProvideFeedbackModalComponent, {
      height: '710px',
      width: '720px',
      panelClass: 'eclaim-popup-modal',
      disableClose: true,
    });
  }
}
